import { render, staticRenderFns } from "./postSetting.vue?vue&type=template&id=843e069a&scoped=true"
import script from "./postSetting.vue?vue&type=script&lang=js"
export * from "./postSetting.vue?vue&type=script&lang=js"
import style0 from "./postSetting.vue?vue&type=style&index=0&id=843e069a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843e069a",
  null
  
)

export default component.exports